export const navItems = [
  { href: "/", label: "首页" },
  { href: "/about", label: "关于我们" },
  { href: "/products", label: "产品中心" },
  { href: "/capabilities", label: "能力中心" },
  { href: "/industries", label: "行业应用" },
  { href: "/knowledge", label: "知识库" },
  { href: "/resources", label: "资料中心" },
  { href: "/calculator", label: "工程计算器" },
  { href: "/trust-center", label: "信任中心" },
  { href: "/rfq", label: "RFQ询价" },
];

export const heroImage = "/fastener-hero.png";

export const channelImages = {
  about: "/fastener-quality.png",
  products: "/channel-products.png",
  capabilities: "/channel-capabilities.png",
  industries: "/channel-industries.png",
  knowledge: "/channel-knowledge.png",
  resources: "/channel-knowledge.png",
  trust: "/fastener-quality.png",
  rfq: "/channel-rfq.png",
};

export const manufacturingBase = {
  zhTitle: "苏州自建紧固件生产基地",
  zhText:
    "2025 年苏州镕亿钛克科技有限公司成立，标志着公司拥有独立的紧固件生产基地。官网应把这一点作为制造能力和供应稳定性的重点展示。",
  enTitle: "Suzhou self-owned fastener manufacturing base",
  enText:
    "Suzhou RonnieTech Technology was established in 2025, marking the company's independent fastener production base and strengthening supply stability.",
  image: "/company-manufacturing-base.png",
};

export const products = [
  {
    name: "Hex Head Bolts",
    cn: "外六角螺栓",
    standard: "DIN 933 / ISO 4017",
    material: "碳钢、不锈钢",
    finish: "镀锌、热浸锌、达克罗",
    use: "机械设备、钢结构和通用装配",
    enMaterial: "Carbon Steel, Stainless Steel",
    enFinish: "Zinc, HDG, Dacromet",
    enUse: "machinery, steel structures, general assembly",
  },
  {
    name: "Prevailing Torque Nuts",
    cn: "防松螺母",
    standard: "DIN 985 / ISO 7040",
    material: "8级、A2、A4",
    finish: "镀锌、发黑",
    use: "振动设备、汽车和轨道交通系统",
    enMaterial: "Class 8, A2, A4",
    enFinish: "Zinc, black oxide",
    enUse: "vibration equipment, automotive, rail systems",
  },
  {
    name: "Socket Cap Screws",
    cn: "内六角圆柱头螺钉",
    standard: "DIN 912 / ISO 4762",
    material: "12.9级合金钢、A2",
    finish: "发黑、锌镍",
    use: "精密设备、工装夹具和定位结构",
    enMaterial: "12.9 Alloy Steel, A2",
    enFinish: "Black oxide, zinc nickel",
    enUse: "precision equipment, tooling, fixtures",
  },
];

export const companyFacts = [
  ["2004", "从天津荣亿精密机械有限公司起步，长期服务工业紧固件与五金产品供应。"],
  ["22年", "紧固件行业经验积累，覆盖通信电子、工业自动化、能源汽车等场景。"],
  ["ISO 9001", "已导入质量管理体系，强调标准化管理、检验追溯与持续改善。"],
  ["4亿PCS", "制造资源覆盖冷镦、车削、冲压、攻牙、铣边、切边和自动检测等工艺。"],
  ["VMI", "提供看板、Two Bin、智能货架、智能货柜和线边物料管理服务。"],
];

export const enCompanyFacts = [
  ["Since 2004", "Started from Tianjin Rongyi Precision Machinery and developed around industrial fasteners and hardware supply."],
  ["22 years", "Fastener industry experience across electronics, industrial automation, energy and automotive applications."],
  ["ISO 9001", "Quality management system with standardized process control, inspection and traceability."],
  ["VMI", "Kanban, smart cabinet, smart rack and point-of-use inventory management services."],
];

export const capabilities = [
  {
    title: "Standard Fastener Supply",
    zhTitle: "标准紧固件供应",
    zhText: "面向机械、电子、建筑、能源和维护场景，提供公制与英制标准紧固件目录和项目供应。",
    text: "Catalog and project supply for metric and inch fasteners used in machinery, electronics, construction, energy and MRO.",
  },
  {
    title: "Custom Fastener Development",
    zhTitle: "非标紧固件开发",
    zhText: "支持按图纸开发、特殊材料、表面处理、样品确认、检测和批量生产。",
    text: "Support for drawing-based parts, special materials, surface treatment, samples, inspection and batch production.",
  },
  {
    title: "Engineering Selection Support",
    zhTitle: "工程选型支持",
    zhText: "围绕防腐、防松、扭矩、强度等级、螺纹啮合和安装风险提供实用建议。",
    text: "Practical recommendations for corrosion, vibration, torque, strength grade, thread engagement and installation risk.",
  },
  {
    title: "Quality Documentation",
    zhTitle: "质量文件支持",
    zhText: "根据项目需要提供材质证明、检测报告、表面处理文件、追溯记录和合规资料。",
    text: "Material certificates, inspection reports, coating documents, traceability records and compliance support when required.",
  },
  {
    title: "VMI & C-parts Logistics",
    zhTitle: "VMI 与 C 类物料管理",
    zhText: "通过 KANBAN、Two Bin、智能货架和线边补货，降低缺料风险、盘点压力和库存成本。",
    text: "KANBAN, Two Bin, smart racks and point-of-use replenishment to reduce shortage risk, counting workload and inventory cost.",
  },
];

export const servicePillars = [
  ["标准紧固件", "提供 ISO、DIN、GB/T、ASTM、ANSI 等标准紧固件，满足通用工业应用和稳定交付需求。"],
  ["非标定制零件", "依据客户图纸加工碳钢、不锈钢、铜等材质零件，支持复杂工艺和特殊表面处理。"],
  ["品牌代理与工业品", "与工业品牌合作，提供胶粘剂、化学品、MRO 辅料等配套产品和技术支持。"],
  ["VMI 物料管理", "根据客户需求提供仓储、Two Bin、智能货架、看板和线边库存方案，降低库存成本。"],
];

export const enServicePillars = [
  ["Standard fasteners", "Supply ISO, DIN, GB/T, ASTM and ANSI standard fasteners for general industrial applications and stable delivery."],
  ["Custom parts", "Manufacture carbon steel, stainless steel and copper parts from drawings, including complex processes and special coatings."],
  ["Brand agency products", "Support adhesive, chemical and MRO product sourcing through authorized industrial brand partnerships."],
  ["VMI services", "Provide warehousing, replenishment, Kanban and point-of-use inventory solutions to reduce customer inventory cost."],
];

export const productFamilies = [
  ["标准件", "平垫圈、六角螺母、弹簧垫圈、圆柱销、弹性销、组合螺钉、六角螺栓、长圆柱销、抽芯铆钉等。", "/product-standard-fasteners.png"],
  ["定制金属件", "铜螺柱、铜垫片、不锈钢隔离柱、弹簧组件、压铆螺母柱、铜嵌件、微型螺母等。", "/product-custom-metal.png"],
  ["塑料紧固件", "尼龙柱、塑料盖、线夹、塑料螺钉、塑料铆钉等轻量化和绝缘应用零件。", "/product-plastic-fasteners.png"],
  ["一站式工业品", "铆钉、夹具、机加工件、冲压件、弹簧、密封件、液压气动元件和电子元件等。", "/product-portfolio.png"],
];

export const enProductFamilies = [
  ["Standard fasteners", "Plain washers, hex nuts, spring washers, dowel pins, spring pins, SEM screws, hex bolts, long dowel pins and blind rivets.", "/product-standard-fasteners.png"],
  ["Customized metal parts", "Brass standoffs, copper washers, stainless standoffs, spring kits, clinching standoffs, inserts and micro nuts.", "/product-custom-metal.png"],
  ["Plastic fasteners", "Nylon spacers, plastic caps, wire clips, nylon screws and plastic rivets for lightweight and insulation uses.", "/product-plastic-fasteners.png"],
  ["One-stop industrial portfolio", "Rivets, clamps, machined parts, stamping parts, springs, sealing parts, hydraulic and pneumatic components.", "/product-portfolio.png"],
];

export const productGallery = [
  ["六角螺栓", "全螺纹标准紧固件，适用于通用工业装配。", "/ppt-product-hex-bolt.jpeg"],
  ["长圆柱销", "高硬度定位与连接零件，适用于精密装配定位。", "/ppt-product-long-pin.jpeg"],
  ["抽芯铆钉", "铝/钢抽芯铆接件，适用于薄板与结构连接。", "/ppt-product-rivet.jpeg"],
  ["铜螺柱", "定制金属件，可用于电子、电气和结构隔离应用。", "/ppt-product-brass-standoff.jpeg"],
  ["尼龙柱", "塑料紧固件，适用于轻量化、绝缘和间隔支撑场景。", "/ppt-product-nylon-spacer.jpeg"],
];

export const enProductGallery = [
  ["Hex bolt", "Fully threaded standard fastener for general industrial assembly.", "/ppt-product-hex-bolt.jpeg"],
  ["Long dowel pin", "Hardened locating and connection part for precision assembly.", "/ppt-product-long-pin.jpeg"],
  ["Blind rivet", "Aluminum/steel blind riveting part for sheet and structural connections.", "/ppt-product-rivet.jpeg"],
  ["Brass standoff", "Customized metal part for electronics, electrical and structural spacing applications.", "/ppt-product-brass-standoff.jpeg"],
  ["Nylon spacer", "Plastic fastener for lightweight, insulation and spacing applications.", "/ppt-product-nylon-spacer.jpeg"],
];

export const uploadedProductPhotos = [
  ["黑色组合螺钉", "黑色表面处理螺钉，适用于电子设备、外壳装配和防眩外观场景。", "/uploaded-product-01.jpg"],
  ["外六角螺栓", "镀锌外六角螺栓，可用于通用机械、结构连接和设备装配。", "/uploaded-product-02.jpg"],
  ["压铆螺母柱", "压铆及嵌入式连接件，适合钣金、电气箱体和模块化结构。", "/uploaded-product-03.jpg"],
  ["六角隔离柱", "内螺纹隔离柱，用于电路板、控制器和结构间隔支撑。", "/uploaded-product-04.jpg"],
  ["铜螺柱", "定制铜螺柱，适用于导电连接、电子装配和结构固定。", "/uploaded-product-05.jpg"],
  ["弹簧与销钉组件", "弹簧、挂钩和销类组合件，可用于机构复位、定位和限位结构。", "/uploaded-product-06.jpg"],
  ["小型铜嵌件", "滚花铜嵌件及微型铜件，适用于塑胶件热熔、注塑嵌入和螺纹增强。", "/uploaded-product-07.jpg"],
  ["不锈钢销轴", "小型销轴与定位件，适用于精密装配、铰接和机械定位。", "/uploaded-product-08.jpg"],
  ["铜垫圈", "铜制垫圈和衬套类零件，可用于导电、密封和间隔应用。", "/uploaded-product-09.jpg"],
];

export const enUploadedProductPhotos = [
  ["Black SEM screws", "Black-finished screws for electronics, enclosure assembly and low-glare appearance requirements.", "/uploaded-product-01.jpg"],
  ["Hex bolts", "Zinc-plated hex bolts for general machinery, structural joints and equipment assembly.", "/uploaded-product-02.jpg"],
  ["Clinching standoffs", "Clinching and embedded fastening parts for sheet metal, electrical enclosures and modular structures.", "/uploaded-product-03.jpg"],
  ["Hex standoffs", "Internally threaded standoffs for PCB, controller and structural spacing applications.", "/uploaded-product-04.jpg"],
  ["Brass threaded studs", "Customized brass studs for conductive joints, electronics assembly and structural fastening.", "/uploaded-product-05.jpg"],
  ["Spring and pin assemblies", "Springs, hooks and pins for return, positioning and limiting mechanisms.", "/uploaded-product-06.jpg"],
  ["Small brass inserts", "Knurled brass inserts and micro brass parts for heat staking, molded-in fastening and thread reinforcement.", "/uploaded-product-07.jpg"],
  ["Stainless pins", "Small shafts and locating pins for precision assembly, hinges and mechanical positioning.", "/uploaded-product-08.jpg"],
  ["Copper washers", "Copper washers and bushing-like parts for conductivity, sealing and spacing applications.", "/uploaded-product-09.jpg"],
];

export const partners = [
  "NOKIA",
  "MOTOROLA",
  "Sony Ericsson",
  "Xiaomi",
  "ASUS",
  "Lenovo",
  "JABIL",
  "FOXCONN",
  "SIEMENS",
  "ABB",
  "GE",
  "HONEYWELL",
  "BYD",
  "JD.com",
];

export const industries = [
  ["Automotive & EV", "High-strength, anti-loosening and traceable fastening for battery modules, fixtures and equipment.", "汽车与新能源", "用于电池模组、夹具和设备的高强度、防松和可追溯紧固方案。"],
  ["Machinery & Equipment", "Reliable assemblies for frames, motors, guards, tooling, conveyors and precision systems.", "机械与设备", "用于机架、电机、防护罩、工装、输送线和精密系统的可靠装配件。"],
  ["Electronics & Electrical", "Small screws, stainless fasteners, enclosure hardware and packaging requirements.", "电子与电气", "小螺钉、不锈钢紧固件、电气箱体五金和包装要求支持。"],
  ["Construction & Energy", "Outdoor corrosion control, anchor systems, hot-dip galvanized parts and project documentation.", "建筑与能源", "户外防腐、锚固系统、热浸锌零件和项目文件支持。"],
];

export const problems = [
  {
    title: "连接松动",
    desc: "高振动、高冲击工况下需要防松组合，而不是单个紧固件替换。",
    answer: "建议使用防松螺母、楔形防松垫圈或预涂胶螺纹件，并根据装配扭矩建立验证表。",
    tags: ["DIN 985", "Wedge Lock", "Thread Locker"],
  },
  {
    title: "户外腐蚀",
    desc: "潮湿、盐雾、户外暴露环境中，材料和表面处理需要同时考虑。",
    answer: "优先评估 A4 不锈钢、热浸锌或锌镍涂层，关键连接可增加盐雾测试和批次追溯。",
    tags: ["A4 / 316", "HDG", "Zinc Nickel"],
  },
  {
    title: "进口件替代",
    desc: "客户有 Bossard、Wurth、McMaster 规格，希望找到等效或降本版本。",
    answer: "通过品牌料号、标准号、尺寸、材料和表面处理交叉匹配，输出等效标准件或非标开发方案。",
    tags: ["Cross Reference", "Cost Down", "Equivalent Parts"],
  },
  {
    title: "非标件开发",
    desc: "图纸、样品或应用条件不完整，需要先判断工艺和可制造性。",
    answer: "从图纸识别、材料建议、冷镦/车削/冲压工艺判断，到打样检测和批量交付形成闭环。",
    tags: ["Drawing RFQ", "DFM", "Sampling"],
  },
];

export const crossReferences = [
  ["DIN 933", "ISO 4017", "Fully threaded hex bolt", "M3-M64"],
  ["DIN 931", "ISO 4014", "Partially threaded hex bolt", "M5-M64"],
  ["DIN 912", "ISO 4762", "Socket head cap screw", "M2-M36"],
  ["DIN 125", "ISO 7089", "Plain washer normal series", "M1.6-M64"],
  ["DIN 985", "ISO 7040", "Nylon insert lock nut", "M3-M36"],
];

export const knowledge = [
  "304 与 316 不锈钢紧固件怎么选",
  "DIN、ISO、ANSI 标准转换方法",
  "8.8、10.9、12.9 级螺栓应用边界",
  "热浸锌、镀锌、锌镍、达克罗的差异",
  "不锈钢咬死问题的预防方案",
  "如何用图纸快速完成紧固件询价",
];

export const resources = [
  "产品目录",
  "RonnieTech 公司介绍",
  "标准对照表",
  "材料选择指南",
  "表面处理指南",
  "VMI / Two Bin 物料管理说明",
  "制造与检测能力清单",
  "螺纹规格参考",
  "询价模板",
];

export const rfqs = [
  {
    company: "EV battery module supplier",
    request: "A2 socket screws, anti-galling requirement, 120k pcs",
    status: "Engineering review",
  },
  {
    company: "Industrial equipment OEM",
    request: "DIN 933 10.9, zinc nickel, RoHS document required",
    status: "Quoted",
  },
  {
    company: "MRO distributor",
    request: "Cross reference for Wurth equivalent parts",
    status: "New",
  },
];
